import { render, staticRenderFns } from "./OrganizationPane.vue?vue&type=template&id=d679518e&scoped=true"
import script from "./OrganizationPane.vue?vue&type=script&lang=js"
export * from "./OrganizationPane.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPane.vue?vue&type=style&index=0&id=d679518e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d679518e",
  null
  
)

export default component.exports